import { Shadow } from "fabric";
import type {
  ShadowDirection,
  ShadowDistance,
  ShadowStyle,
  ShapeLayer,
  TextLayer,
} from "../types.ts";

export const updateLayerShadowStyle = (
  layer: TextLayer | ShapeLayer,
  shadowStyle: ShadowStyle,
  shadowDirection: ShadowDirection,
  shadowDistance: ShadowDistance,
) => {
  layer.shadowStyle = shadowStyle;
  layer.shadowDirection = shadowDirection;
  layer.shadowDistance = shadowDistance;

  const { offsetX, offsetY } = getShadowOffset(shadowDistance, shadowDirection);

  switch (shadowStyle) {
    case "none":
      layer.set({
        shadow: undefined,
      });
      break;
    case "soft":
      layer.set({
        shadow: new Shadow({
          color: "rgba(0, 0, 0, 0.15)",
          blur: 10,
          offsetX,
          offsetY,
        }),
      });
      break;
    case "medium":
      layer.set({
        shadow: new Shadow({
          color: "rgba(0, 0, 0, 0.3)",
          blur: 15,
          offsetX,
          offsetY,
        }),
      });
      break;
    case "strong":
      layer.set({
        shadow: new Shadow({
          color: "rgba(0, 0, 0, 0.45)",
          blur: 20,
          offsetX,
          offsetY,
        }),
      });
      break;
  }
};

const getShadowOffset = (
  shadowDistance: ShadowDistance,
  shadowDirection: ShadowDirection,
) => {
  const offset =
    shadowDistance === "small" ? 2 : shadowDistance === "medium" ? 4 : 6;
  switch (shadowDirection) {
    case "top":
      return { offsetX: 0, offsetY: -offset };
    case "right":
      return { offsetX: offset, offsetY: 0 };
    case "bottom":
      return { offsetX: 0, offsetY: offset };
    case "left":
      return { offsetX: -offset, offsetY: 0 };
  }
};
